import * as actions from '../constants/actions'
import { createActionCreator } from '../utils/redux'

export const selectionPaginationPrevious = createActionCreator(actions.SELECTION_PAGINATION_PREVIOUS)

export const selectionPaginationNext = createActionCreator(actions.SELECTION_PAGINATION_NEXT)



// WEBPACK FOOTER //
// ./src/actionCreators/selectionPagination.js